import {IBizRedEnvelope, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {ARedEnvelope} from "@/views/editor/service/red_envelope/red_envelope";

export interface IBusinessRedPacketSetMeta {
    enable: boolean;
    amount: number[];
    limit_pre_day: number;
}

export interface IBusinessRedPacketMeta {
    on_view: IBusinessRedPacketSetMeta;
    on_invite: IBusinessRedPacketSetMeta;
    area_limit: string[];
}

export default class RedPacket extends ARedEnvelope implements IBizRedEnvelope {
    readonly subs: CheckboxOptionType[] = [{value: 'view', label: '浏览红包'}, {value: 'invite', label: '邀请红包'}];
    readonly opt: IBusinessRedPacketMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IBusinessRedPacketMeta;
    }

    resetMeta(): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs.map(s => s.value as string))
        return this;
    }

}